/* Ciano · cesta lateral más limpia (12/10/2026): «Tu cesta» con número, nombre corto del café,
   opciones en una sola línea («1 kg · Café en grano»), precio por unidad solo si hay más de una
   y total sin «EUR». Los estilos están en snippets/ciano-cesta-estilo.liquid. */
(function () {
  var EN = window.CIANO_EN, CA = window.CIANO_CA;
  function corto(t) {
    var c = t.split(' · ')[0].split(' | ')[0].replace(/^Blend\s+/i, '').trim();
    return c || t;
  }
  function valor(v) {
    return v.replace(/,\s*$/, '').trim()
      .replace(/^250\s?gr?$/i, '250 g').replace(/^500\s?g$/i, '500 g')
      .replace(/^(\d+)\s?kg$/i, '$1 kg');
  }
  function pulir() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var h = d.querySelector('.drawer__heading');
    if (h && !h.hasAttribute('data-ciano')) {
      var n = 0;
      d.querySelectorAll('.cart-item .quantity__input').forEach(function (i) { n += parseInt(i.value, 10) || 0; });
      h.setAttribute('data-ciano', '1');
      h.textContent = EN ? 'Your basket' : CA ? 'La teva cistella' : 'Tu cesta';
      if (n) { var b = document.createElement('span'); b.className = 'ciano-cesta-n'; b.textContent = n; h.appendChild(b); }
    }
    d.querySelectorAll('.cart-item:not([data-ciano])').forEach(function (it) {
      it.setAttribute('data-ciano', '1');
      var a = it.querySelector('.cart-item__name');
      if (a) { var t = a.textContent.trim(); a.textContent = corto(t); a.setAttribute('title', t); }
      var q = it.querySelector('.quantity__input'), qn = q ? parseInt(q.value, 10) || 1 : 1;
      var pu = it.querySelector('.cart-item__title + .product-option');
      if (pu) {
        if (qn > 1) { pu.textContent = qn + ' × ' + pu.textContent.trim(); pu.classList.add('ciano-ud'); }
        else pu.remove();
      }
      var dl = it.querySelector('.cart-item__details dl');
      if (dl) {
        var partes = [];
        Array.prototype.slice.call(dl.children).forEach(function (po) {
          if (!po.classList || !po.classList.contains('product-option')) return;
          var dt = po.querySelector('dt'), dd = po.querySelector('dd');
          if (!dt || !dd) return;
          var l = dt.textContent.replace(/:\s*$/, '').trim(), v = valor(dd.textContent);
          if (l.indexOf('·') >= 0) partes.push(l.split('·').pop().trim() + ': ' + v);
          else if (/(peso|^pes$|weight|molid|molien|mòlt|grind|format|tama|size)/i.test(l)) partes.push(v);
          else partes.push(l + ': ' + v);
          po.remove();
        });
        if (partes.length) {
          var x = document.createElement('div');
          x.className = 'product-option ciano-opc';
          x.textContent = partes.join(' · ');
          dl.insertBefore(x, dl.firstChild);
        }
      }
    });
    var th = d.querySelector('.totals__total');
    if (th && !th.hasAttribute('data-ciano')) { th.setAttribute('data-ciano', '1'); th.textContent = 'Total'; }
    var tx = d.querySelector('.tax-note');
    if (tx && !tx.hasAttribute('data-ciano') && /impuestos incluidos|impostos inclosos|taxes included/i.test(tx.textContent)) {
      tx.setAttribute('data-ciano', '1');
      tx.textContent = EN ? 'VAT included. Shipping and discounts at checkout.' : CA ? 'IVA inclòs. Enviament i descomptes, en pagar.' : 'IVA incluido. Envío y descuentos, al pagar.';
    }
    var tv = d.querySelector('.totals__total-value');
    if (tv && /\sEUR\s*$/.test(tv.textContent)) tv.textContent = tv.textContent.replace(/\s*EUR\s*$/, '').trim();
  }
  function arranca() {
    pulir();
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(function () { pulir(); }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
